module.exports = __webpack_public_path__ + "static/media/monroneyLabel.bed521bd.png";